import { Injectable, inject, signal } from '@angular/core';
import { PlatformAuthService } from './platform-auth.service';
import { PlatformJobboardLoginModalService } from './platform-jobboard-login-modal.service';
import { PlatformApplyWithProfileContext } from './platform-jobs.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformApplyWithProfileService {
  private readonly auth = inject(PlatformAuthService);
  private readonly loginModal = inject(PlatformJobboardLoginModalService);

  readonly context = signal<PlatformApplyWithProfileContext | null>(null);
  private pendingContext: PlatformApplyWithProfileContext | null = null;

  /**
   * Opens the apply-with-profile modal, or the login modal when no session exists.
   * @param context - Job and required-field context for the modal
   */
  open(context: PlatformApplyWithProfileContext): void {
    if (!this.auth.loggedIn()) {
      this.pendingContext = context;
      this.loginModal.open();
      return;
    }
    this.pendingContext = null;
    this.context.set(context);
  }

  /**
   * Clears the current apply-with-profile context.
   */
  close(): void {
    this.context.set(null);
  }

  /**
   * Opens a previously requested apply-with-profile modal after login.
   */
  resumeAfterLogin(): void {
    const pending = this.pendingContext;
    this.pendingContext = null;
    if (!pending || !this.auth.loggedIn()) {
      return;
    }
    this.context.set(pending);
  }
}
